import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ElementRef, EventEmitter,
  HostListener, Inject, OnDestroy,
  OnInit, Output, PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ButtonComponent } from '@app/shared/button/button.component';

@Component({
  selector: 'app-header-slider',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './header-slider.component.html',
  styleUrls: ['./header-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSliderComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('slideContainer', { static: false }) slideContainer!: ElementRef;

  @Output() clickImage: EventEmitter<string> = new EventEmitter<string>();

  initialSlides: string[] = [
    'assets/images/home-page/header/image-2.webp',
    'assets/images/home-page/header/image-7.webp',
    'assets/images/home-page/header/image-4.webp',
    'assets/images/home-page/header/image-5.webp',
  ];

  slides: string[] = [];
  currentIndex = 0;
  visibleSlides: string[] = [];
  interval: any;
  isTransitioning = false;
  itemWidth: number;

  @HostListener('window:resize')
  onResize() {
    this.calculateSizes();
  }

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}


  ngOnInit(): void {
    this.slides = [...this.initialSlides];
    if (isPlatformBrowser(this.platformId)) {
      this.startAutoPlay();
    }
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.calculateSizes();
  }

  ngOnDestroy() {
    this.stopAutoPlay();
  }

  startAutoPlay(): void {
    this.interval = setInterval(() => {
      this.nextSlide();
    }, 7000);
  }

  stopAutoPlay(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  calculateSizes() {
    if (isPlatformBrowser(this.platformId) && this.slideContainer) {
      const slideElements = this.slideContainer.nativeElement.querySelectorAll('.slide img');

      Promise.all(Array.from(slideElements).map((img: any) => {
          return new Promise<void>((resolve) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = () => resolve();
            }
        });
      })).then(() => {
        const slideElement = this.slideContainer.nativeElement.querySelector('.slide');
        if (slideElement) {
          this.itemWidth = slideElement.clientWidth;
        }
      });
    }
  }

  nextSlide(): void {
    if (this.isTransitioning) return;

    this.isTransitioning = true;
    this.currentIndex++;

    if (this.currentIndex >= this.slides.length - 3) {
      this.slides = [...this.slides, ...this.initialSlides];

      // Ограничиваем массив до 12 элементов
      if (this.slides.length > 12) {
        const excess = this.slides.length - 12;
        this.slides = this.slides.slice(excess);
        this.currentIndex -= excess;
      }
    }

    setTimeout(() => {
      this.isTransitioning = false;
    }, 700);
    this.cdr.detectChanges();
  }

  prevSlide(): void {
    if (this.isTransitioning || this.currentIndex === 0) return;

    this.isTransitioning = true;
    this.currentIndex--;

    setTimeout(() => {
      this.isTransitioning = false;
    }, 700);
    this.cdr.detectChanges();
  }

  getSlideOffset(): number {
    return this.currentIndex * (this.itemWidth + 12);
  }

  onEvent(slide: string) {
    this.clickImage.emit(slide);
  }
}
